import * as React from "react";
import { Button, Grid, Table } from "semantic-ui-react";
import { format } from "date-fns";

import { useDispatch, useSelector } from "@teamprevent/customer-redux";

import { customerDocumentsSelector } from "../selectors";
import { loadDocuments } from "../actions";

export const All = () => {
    const customerDocuments = useSelector(customerDocumentsSelector).sort((a, b) => a.name.localeCompare(b.name));

    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(loadDocuments());
    }, [dispatch]);

    return (
        <Grid container className="nomargintop">
            <Grid.Row>
                <Grid.Column width={16}>
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Document Name</Table.HeaderCell>
                                <Table.HeaderCell>Created</Table.HeaderCell>
                                <Table.HeaderCell>Url</Table.HeaderCell>
                                <Table.HeaderCell>Download</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {customerDocuments && customerDocuments.map(customerDocument => (
                                <Table.Row key={customerDocument.id}>
                                    <Table.Cell>
                                        {customerDocument.name}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {format(customerDocument.dateCreated, "P p")}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {customerDocument.url
                                            ? <a href={customerDocument.url} target="_blank" rel="noopener noreferrer">
                                                <Button icon="envelope open outline" content="Open" />
                                            </a>
                                            : <></>}
                                    </Table.Cell>
                                    <Table.Cell>
                                        {customerDocument.blobId && customerDocument.fileName
                                            ? <a
                                                // eslint-disable-next-line max-len
                                                href={`/api/customerDocument/document/${customerDocument.blobId}?fileName=${customerDocument.fileName}`}
                                            >
                                                <Button content={customerDocument.fileName} type="button" />
                                            </a>
                                            : <></>}
                                    </Table.Cell>
                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};
